import { PopoverOrigin } from "@mui/material/Popover";

const centeredAnchorOrigin: PopoverOrigin = {
    vertical: "bottom",
    horizontal: "center"
};

const centeredTransformOrigin: PopoverOrigin = {
    vertical: "top",
    horizontal: "center"
};

const leftAnchorOrigin: PopoverOrigin = {
    vertical: "bottom",
    horizontal: "left"
};

const leftTransformOrigin: PopoverOrigin = {
    vertical: "top",
    horizontal: "left"
};

export {
    centeredAnchorOrigin,
    centeredTransformOrigin,
    leftAnchorOrigin,
    leftTransformOrigin
};
